import { Injector } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { FieldDefinition } from "../../../../../sections/webtrader/webtrader/message/fieldDefinition";
import { Art57Node } from "../../Art57Node/Art57Node";
import { FieldsErrorsControl } from "../../../FieldErrorsControl";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { XEVPRMImportedAck } from "../../../Data/Art57Data/XEVPRMImportedAck";
import { TreeNodeXEVPRMAck } from "../../Art57Node/Entity/TreeNodeXEVPRMAck";


export class TreeNodeXEVPRMImportedAck extends Art57Node {
  fieldsErrorsControl = new FieldsErrorsControl();

  constructor(private injector: Injector) {
    super(
      injector,
      new XEVPRMImportedAck(
        new FormGroup({}),
        new FieldDefinition(injector),
        {}
      ),
      'EVPRACK - {param1} - {param2}'
    );
    this.ioc!.get(Art57Section).generateNumColumValue(this);
    this.refreshLabel();
    this.expanded = true;
    this.createChildTemplate();
  }

  override refreshLabel(lazy: boolean = true): void {
    let param1 = '';
    let param2 = '';

    if (
      this.data &&
      this.data.model &&
      this.data.model.messagesenderidentifier
    ) {
      param1 = this.data.model.messagesenderidentifier
    }
    if (
      this.data &&
      this.data.model &&
      this.data.model.messagedate
    ) {
      param2 = this.data.model.messagedate
    }

    this.label = this.labelTemplate.replace('{param1}', param1).replace('{param2}', param2);
  }

  override getListItem(): any[] {
    return [
      this.data.model && this.data.model.messagetype
        ? this.data.model.messagetype :
        '',
      this.data.model && this.data.model.messagenumb
        ? this.data.model.messagenumb :
        '',
      this.data.model && this.data.model.messagedate
        ? this.data.model.messagedate
        : '',
    ];
  }

  override createChildTemplate(): Art57Node[] | null {
    let art57NodesTemplate: Art57Node[] = [];

    art57NodesTemplate.push(new TreeNodeXEVPRMAck(this.ioc!));

    art57NodesTemplate.map((nodeToAdd) => {
      this.children?.push(nodeToAdd);
    });

    return art57NodesTemplate;
  }

  override setMessage(jsonObject: any) {

    //Set XEVPRMAck (only this children must exist) 
    (this.children![0] as TreeNodeXEVPRMAck).setMessage(jsonObject.acknowledgment);

  }




}